export default "__VITE_ASSET__DYa8RErX__"